import { hasVisibleText } from '@/helpers/richText';

/**
 * Fields of `technicalReview` that must be filled for "DC - geprüft = Ja" (see feature page
 * projekt-technische-pruefung). Only the block checks it; the API saves without the rule.
 */
export const TECHNICAL_REVIEW_DC_REQUIRED_FIELDS = [
  'dcNotes',
  'expectedDcTimeExpenditureInSeconds',
  'dcInstallationTeamNotes',
];

/**
 * Fields of `technicalReview` that must be filled for "AC - geprüft = Ja"; `installationTeamNotes`
 * is the AC team info (see feature page projekt-technische-pruefung). Only the block checks it.
 */
export const TECHNICAL_REVIEW_AC_REQUIRED_FIELDS = [
  'acNotes',
  'expectedAcTimeExpenditureInSeconds',
  'installationTeamNotes',
];

/** A planned duration counts when it is above zero, rich text when it has visible text. */
const isFilled = (value) => {
  if (typeof value === 'number') {
    return value > 0;
  }
  if (typeof value === 'string') {
    return hasVisibleText(value);
  }

  return false;
};

/**
 * Required fields of one side of the technical review that are empty; empty list when complete.
 * @param {Object} technicalReview
 * @param {string[]} requiredFields e.g. `TECHNICAL_REVIEW_DC_REQUIRED_FIELDS`
 * @returns {string[]}
 */
export const findMissingInspectionFields = (technicalReview, requiredFields) =>
  requiredFields.filter((fieldName) => !isFilled(technicalReview[fieldName]));
